/**
 * @fileoverview Change Password page UI (forgot-password code confirmation).
 * @module pages/changePassword/ChangePasswordView
 */
import styles from "../../styles/ChangePasswordView.module.css";
import {
  ChangePasswordActions,
  ChangePasswordHeader,
  PasswordFieldsSection,
  VerificationCodeSection,
} from "./ChangePasswordSections.jsx";
import useChangePasswordView from "./useChangePasswordView.js";

const ChangePasswordView = () => {
  const {
    t,
    userEmail,
    confirmationCode,
    setConfirmationCode,
    values,
    handlePasswordChange,
    handleConfirmPasswordChange,
    handleToggleShowPassword,
    handleToggleShowConfirmPassword,
    renderOtpInput,
    handleNavigatePasswordRecovery,
    changePassword,
    buttonDisabled,
    getOtpInputSize,
  } = useChangePasswordView();
  const otpInputSize = getOtpInputSize();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <ChangePasswordHeader
          t={t}
          userEmail={userEmail}
          loading={values.loading}
        />
        <VerificationCodeSection
          t={t}
          confirmationCode={confirmationCode}
          setConfirmationCode={setConfirmationCode}
          showCodeError={values.showCodeError}
          errorMessage={values.errorMessage}
          renderOtpInput={renderOtpInput}
          otpInputSize={otpInputSize}
        />
        <PasswordFieldsSection
          t={t}
          values={values}
          handlePasswordChange={handlePasswordChange}
          handleConfirmPasswordChange={handleConfirmPasswordChange}
          handleToggleShowPassword={handleToggleShowPassword}
          handleToggleShowConfirmPassword={handleToggleShowConfirmPassword}
        />
        <ChangePasswordActions
          t={t}
          onCancel={handleNavigatePasswordRecovery}
          onConfirm={changePassword}
          confirmDisabled={buttonDisabled}
        />
      </div>
    </div>
  );
};

export default ChangePasswordView;
